
<template>
  <div class="preview-container large" v-if="selectedProject.id">
    <div
      v-if="
        selectedPageBlocks.length === 0 && selectedPageBlocksLoading == false
      "
      class="text-center pa-5"
    >
      <v-btn color="primary" @click="addNewBlockEmptyClick()"
        ><v-icon small>mdi-plus</v-icon> Add First Block</v-btn
      >
    </div>
    <div class="pa-3 text-center" v-if="selectedPageBlocksLoading">
      Getting blocks...
      <div style="width: 300px; margin: auto" v-if="selectedPageBlocksLoading">
        <v-progress-linear
          indeterminate
          color="primary"
          :size="40"
        ></v-progress-linear>
      </div>
    </div>
    <v-dialog v-model="newBlockDiaLog" width="70%" scrollable>
      <NewBlockDialogContent
        v-if="newBlockDiaLog"
        @close="newBlockDiaLog = false"
        :order="order"
        :demo="false"
      ></NewBlockDialogContent>
    </v-dialog>
    <div class="previewer-container" v-show="!selectedPageBlocksLoading">
      <ProjectPreviewer
        ref="iframe"
        :project="selectedProject"
        :blocks="selectedPageBlocks"
        :editingBlockId="editingBlockId"
        :resolution="selectedResolution"
        :showBlockManagement="true"
        @add-new-block="addNewBlockClick($event)"
        @edit-click="bus.$emit('edit-block', $event)"
        @up-click="bus.$emit('up-block', $event)"
        @down-click="bus.$emit('down-block', $event)"
        @delete-click="bus.$emit('delete-block', $event)"
      />
    </div>
    <v-dialog :value="showForceDeleteBlockDialog" width="400px">
      <ModalStructure @close="showForceDeleteBlockDialog = false">
        <div slot="title">Error Deleting Block</div>
        <div slot="body">
          <v-alert type="error" border="left" text
            >This block is used in other pages. Force delete anyway?</v-alert
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small @click="showForceDeleteBlockDialog = false"
              >Cancel</v-btn
            >
            <v-btn text small color="error" @click="forceDeleteBlock()"
              >Delete</v-btn
            >
          </v-card-actions>
        </div>
      </ModalStructure>
    </v-dialog>
  </div>
</template>

<script>
import NewBlockDialogContent from "./NewBlockDialogContent";
import ProjectPreviewer from "./ProjectPreviewer";
import projectMixin from "./project-mixin";

function p(x) {
  return parseFloat(x);
}

export default {
  components: { NewBlockDialogContent, ProjectPreviewer },
  mixins: [projectMixin],
  data() {
    return {
      newBlockDiaLog: false,
      order: 1000,
      showForceDeleteBlockDialog: false,
      forceDeleteBlockId: null,
    };
  },
  watch: {
    "selectedProject.siteTheme.fontFamily1": function (newVal) {
      if (newVal) {
        this.updateGoogleFontFaceLink(newVal);
      }
    },
    "selectedProject.siteTheme.fontFamily2": function (newVal) {
      if (newVal) {
        this.updateGoogleFontFaceLink(newVal);
      }
    },
  },
  async created() {
    // this.bus.$on("block-created", this.checkStickyBarAndReloadIframe);
    this.bus.$on("delete-block", this.onDeleteBlock);
  },
  destroyed() {
    // this.bus.$off("block-created", this.checkStickyBarAndReloadIframe);
    this.bus.$off("delete-block", this.onDeleteBlock);
  },
  methods: {
    // TODO: damn problematic STICKY_BAR
    checkStickyBarAndReloadIframe(block) {
      if (block.type === "STICKY_BAR") {
        const iframe = this.$refs.iframe.$el;
        iframe.contentWindow.location.reload();
        iframe.addEventListener(
          "load",
          async () => await this.iframeInjectResources(),
          true
        );
      }
    },
    calculateBlockOrder(block, index) {
      const nextBlock = this.selectedPageBlocks[index + 1];
      if (nextBlock) {
        return (p(nextBlock.order) + p(block.order)) / 2;
      } else {
        return p(block.order) + 1000;
      }
    },
    addNewBlockEmptyClick() {
      this.newBlockDiaLog = true;
      this.order = "1000";
    },
    addNewBlockClick({ block, index }) {
      this.newBlockDiaLog = true;
      this.order = this.calculateBlockOrder(block, index);
    },
    async onDeleteBlock(block) {
      if (confirm("Delete?")) {
        const result = await this.deleteBlockFromPage({
          blockId: block.id,
          force: false,
        });
        if (result.message === "ERROR_REFERENCED_FROM_OTHER_BLOCKS") {
          this.showForceDeleteBlockDialog = true;
          this.forceDeleteBlockId = block.id;
        } else if (result.message === "OK") {
          this.broadcastBlockDeleted();
        }
      }
      // this.checkStickyBarAndReloadIframe(block);
    },
    async forceDeleteBlock() {
      this.showForceDeleteBlockDialog = false;
      if (this.forceDeleteBlockId) {
        const result = await this.deleteBlockFromPage({
          blockId: this.forceDeleteBlockId,
          force: true,
        });
        if (result.message === "OK") {
          this.broadcastBlockDeleted();
        }
      }
    },
  },
};
</script>

<style scoped>
.preview-container {
  width: 100%;
  height: 100%;
  border: none;
  margin-top: 120px;
  transition: margin-left 200ms;
}

.previewer-container {
  height: 100%;
  width: 100%;
}

.previewer-container.mobile,
.previewer-container.tablet {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>